export default __webpack_public_path__ + "41ac7e6e681a0f370b45f6082b301d92.svg";